/**
 * Map API event type to visual category (D-07).
 * test + appointment collapse to one purple dot ("test-appt").
 *
 * NOTE (Wave 1 isolation): parameter type is `string` here so this file ships
 * standalone without depending on src/types/event.ts (Plan 36-02 Task 1).
 * Plan 36-02 Task 1 will refactor this signature to use the strict EventType
 * union (imported from "../../types/event"). Call sites in Plans 36-05/06
 * already pass `event.type` (typed as EventType) so the refactor is type-safe.
 */
export type EventVisualCategory = "test-appt" | "meds" | "cycle" | "admin";

export function getEventTypeColor(type: string): EventVisualCategory {
	switch (type) {
		case "test":
		case "appointment":
			return "test-appt";
		case "medication":
			return "meds";
		case "cycle":
			return "cycle";
		case "admin":
			return "admin";
		default:
			// Defensive: should be unreachable once Plan 36-02 narrows the param.
			// Returning "admin" as a fallback color (yellow) keeps the UI rendering
			// rather than throwing on unexpected type strings.
			return "admin";
	}
}
